/**
 * Page Loader - With logo animation
 * Hides the loading overlay when page is fully loaded AND logo animation completes
 */

(function() {
  'use strict';

  const minDisplayTime = 300; // Reduced from 500ms for better balance
  const startTime = Date.now();
  
  let pageLoaded = false;
  let animationComplete = false;
  let fallbackTimer = null;

  function tryHideLoader() {
    // Only hide when both page is loaded AND animation is complete
    if (!pageLoaded || !animationComplete) return;

    if (fallbackTimer) {
      clearTimeout(fallbackTimer);
      fallbackTimer = null;
    }

    const loader = document.getElementById('pageLoader');
    if (!loader) return;

    const elapsed = Date.now() - startTime;
    const remaining = Math.max(0, minDisplayTime - elapsed);

    // Ensure loader is shown for at least minDisplayTime
    setTimeout(function() {
      loader.classList.add('hidden');
      document.body.classList.remove('page-loading');

      // Remove loader from DOM after transition
      setTimeout(function() {
        if (loader.parentNode) {
          loader.parentNode.removeChild(loader);
        }
      }, 700); // Match CSS transition duration
    }, remaining);
  }

  function onPageLoad() {
    pageLoaded = true;
    tryHideLoader();
  }

  function onAnimationComplete() {
    animationComplete = true;
    tryHideLoader();
  }

  // Add loading class to body
  if (document.body) {
    document.body.classList.add('page-loading');
  } else {
    document.addEventListener('DOMContentLoaded', function() {
      document.body.classList.add('page-loading');
    });
  }

  // Listen for logo animation completion
  window.addEventListener('loaderAnimationComplete', onAnimationComplete);

  // Hide loader when page is fully loaded (but wait for animation)
  if (document.readyState === 'complete') {
    onPageLoad();
  } else {
    window.addEventListener('load', onPageLoad);
  }

  // Fallback: ensure loader never blocks longer than 5 seconds
  fallbackTimer = setTimeout(function() {
    const loader = document.getElementById('pageLoader');
    const alreadyHidden = loader && loader.classList.contains('hidden');

    if (!alreadyHidden) {
      pageLoaded = true;
      animationComplete = true;
      tryHideLoader();
    }
  }, 5000);
})();

